
export const mergeDirtyFieldsWithSkipped = <T extends Record<string, any>>(
  dirtyFields: T,
  skipMap?: T,
): T => {
  if (!skipMap) return dirtyFields;

  const merged: any = Array.isArray(dirtyFields)
    ? [...dirtyFields]
    : { ...dirtyFields };

  if (Array.isArray(merged)) {
    const skipTemplate = Array.isArray(skipMap) ? skipMap[0] : skipMap;

    return merged.map((item) => typeof item === 'object'
      ? mergeDirtyFieldsWithSkipped(item, skipTemplate)
      : item
    ) as unknown as T;
  }

  for (const key of Object.keys(skipMap)) {
    const skipValue = skipMap[key];
    const dirtyValue = merged[key];

    if (skipValue === true) {
      merged[key] = true;
    } else if (Array.isArray(skipValue)) {
      const template = skipValue[0];
      if (Array.isArray(dirtyValue)) {
        merged[key] = dirtyValue.map((item: any) =>
          mergeDirtyFieldsWithSkipped(item, template)
        );
      } else {
        merged[key] = [mergeDirtyFieldsWithSkipped({}, template)];
      }
    } else if (
      typeof skipValue === 'object' &&
      skipValue !== null &&
      typeof dirtyValue === 'object'
    ) {
      merged[key] = mergeDirtyFieldsWithSkipped(dirtyValue, skipValue);
    } else if (skipValue) {
      merged[key] = skipValue;
    }
  }

  return merged;
}
